export const WIDGET_NAMES = {
  net_sales_by_provider: "Net Sales by Provider",
  net_sales_by_clinic: "Net Sales by Clinic",
  shopify_orders: "Shopify orders",
  revenue_per_hour: "Revenue per Hour",
  appointment_engagement: "Busiest Day",
};
